var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-file-list-item"},[_c('styled-button',{staticClass:"c-file-list-item-content",attrs:{"to":{
      name: 'file',
      params: {
        fileSlug: _vm.file.fileSlug
      }
    }}},[_c('div',{staticClass:"c-file-list-item-type"},[_vm._v(" "+_vm._s(_vm.file.typeName)+" ")]),_c('div',{staticClass:"c-file-list-item-name"},[_vm._v(" "+_vm._s(_vm.file.name)+_vm._s(_vm.file.fileExtension)+" ")]),_c('div',{staticClass:"c-file-list-item-locked"},[_vm._v(" "+_vm._s(_vm.file.locked)+" ")]),_c('div',{staticClass:"c-file-list-item-size"},[_vm._v(" "+_vm._s(_vm.size)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }